export default __webpack_public_path__ + "static/media/logo--white.8f71b19f.png";